module.exports = __webpack_public_path__ + "img/Ekko-Header-2-Right@2x.9cd816ee.png";